import { z } from "zod";
import { isValidPhoneNumber } from "libphonenumber-js";
function defaultTranslate(key) {
    const defaults = {
        invalidPhone: "Invalid phone number",
        required: "This field is required",
    };
    return defaults[key] ?? key;
}
export function createPhoneSchema(t = defaultTranslate, { required = true, allowEmpty = false, } = {}) {
    if (allowEmpty) {
        return z.string().refine((value) => value.length === 0 || isValidPhoneNumber(value), { message: t("invalidPhone") });
    }
    if (required) {
        return z
            .string()
            .min(1, t("required"))
            .refine((value) => isValidPhoneNumber(value), {
            message: t("invalidPhone"),
        });
    }
    return z
        .string()
        .optional()
        .refine((value) => !value || value.length === 0 || isValidPhoneNumber(value), { message: t("invalidPhone") });
}
